import { ConstantsHelper } from '@/lib/constants/helper';

export const getTissProcedimentoTabela = (tabela: string | undefined) =>
  ConstantsHelper.tiss.tabelas.find(f => f.value === tabela)?.label;

export const getTissProcedimentoSexo = (sexo: string | undefined) =>
  ConstantsHelper.tiss.procedimentoSexos.find(f => f.value === sexo)?.label;
